module.exports = __webpack_public_path__ + "img/trainer.eecc81a4.png";